<template>
  <v-app style="background:#f0f3f7">
    <div v-if="isLogged && !loading">
      <CpeNavbar v-if="isCpe()" />
      <NavbarMember v-else-if="isMember()" />
      <Navbar v-else />
      <Notification />
    </div>
    <Appbar v-if="isLogged" />
    <v-content>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>
    <Footer></Footer>
  </v-app>
</template>

<script>
import CpeNavbar from "@/components/shared/CpeNavbar";
import Navbar from "@/components/shared/Navbar";
import NavbarMember from "@/components/shared/NavbarMember";
import Appbar from "@/components/shared/Appbar";
import Footer from "@/components/shared/Footer";
import Notification from "@/components/shared/Notification";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  components: { Navbar, Appbar, Footer, Notification, NavbarMember, CpeNavbar },
  data: () => ({}),

  computed: {
    ...mapGetters({
      isLogged: "token",
      drawer: "drawer",
      notificationDrawer: "notificationDrawer",
      loading: "loading",
      role: "getRole",
    }),
  },

  watch: {
    getRole() {
      this.isMember();
    },
  },

  methods: {
    isMember() {
      if (this.role == "CLUB_MEMBER") {
        return true;
      } else {
        return false;
      }
    },

    isCpe() {
      if (this.role == "CLUBS_PERFORMANCE_EVALUATION") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
